<app-expansion-panel
  [titre]="indiceResultats().nom"
  [item]="indiceResultats()"
  [actions]="peutModifier() ? indiceActions : []"
  [cdkDragDisabled]="!peutModifier()"
  [cdkDragData]="indiceResultats()"
  [draggable]="peutModifier()"
  cdkDrag
>
  <div class="ml-sm" ngProjectAs="chipLeft">
    <app-chip [label]="indicateurs().length | i18nPlural: indicateurMapping" />
  </div>
  <div class="p-md gap-md flex flex-col">
    @if (peutModifier()) {
      <button class="w-fit" (click)="ajoutIndicateurPerformance()" hlmBtn variant="secondary">
        <ng-icon name="lucidePlus" /> Ajouter un indicateur de performance
      </button>
    }
    <div class="gap-xs grid">
      @for (indicateur of indicateurs() | trierPar: 'nom'; track indicateur.id) {
        <app-indicateur-item
          [phases]="phases()"
          [referentiel]="referentiel()"
          [peutModifier]="peutModifier()"
          [indicateur]="indicateur"
          [indiceResultats]="indiceResultats()"
        />
      } @empty {
        <p class="paragraph-medium-medium text-content-secondary">
          Aucun indicateur de performance associé à cet indice de performance.
        </p>
      }
    </div>
  </div>
</app-expansion-panel>
